export default __webpack_public_path__ + "static/media/expired.0c1f4ea7.png";